import App from './App.svelte';
import { wireupMaps, useGateway } from './component/customMap';
import './polyfill';
import { showSpeciesInfo } from './component/aisReserveAssetLayer';
import { activatePin } from './component/aisReserveAssetLayer';
const target = document.getElementById('customMapSvelte');

const app = new App({
  target,
});

export { app, wireupMaps, useGateway, showSpeciesInfo, activatePin };